import { objectOf, arrayOf, enumOf, tupleOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type { DayOfWeek, GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult } from "./types";

const isDayOfWeek = enumOf<DayOfWeek>("sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday");

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingResult>({
    frequencies: arrayOf(number),
    daysOfWeek: arrayOf(isDayOfWeek),
    quietHours: tupleOf(number, number),
    timezone: enumOf<"default" | "user">("default", "user"),
  });
